var _rect, _rect2, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingrwStIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FEF7C3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#FEFBE8",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 20H23.8C22.1198 20 21.2798 20 20.638 20.327C20.0735 20.6146 19.6146 21.0735 19.327 21.638C19 22.2798 19 23.1198 19 24.8V30C19 30.93 19 31.395 19.1022 31.7765C19.3796 32.8117 20.1883 33.6204 21.2235 33.8978C21.605 34 22.07 34 23 34V36.3355C23 36.8683 23 37.1348 23.1092 37.2716C23.2042 37.3906 23.3483 37.4599 23.5005 37.4597C23.6756 37.4595 23.8837 37.2931 24.2998 36.9602L26.6852 35.0518C27.1725 34.662 27.4162 34.4671 27.6875 34.3285C27.9282 34.2055 28.1844 34.1156 28.4492 34.0613C28.7477 34 29.0597 34 29.6837 34H31.2C32.8802 34 33.7202 34 34.362 33.673C34.9265 33.3854 35.3854 32.9265 35.673 32.362C36 31.7202 36 30.8802 36 29.2V29",
    stroke: "#EAAA08",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6945_17466)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.6413 17.7263C33.7566 17.4928 33.8142 17.3761 33.8924 17.3388C33.9605 17.3063 34.0395 17.3063 34.1076 17.3388C34.1858 17.3761 34.2434 17.4928 34.3587 17.7263L35.452 19.9413C35.4861 20.0102 35.5031 20.0447 35.5279 20.0714C35.5499 20.0951 35.5763 20.1143 35.6057 20.1279C35.6388 20.1433 35.6768 20.1489 35.7529 20.16L38.1985 20.5175C38.456 20.5551 38.5848 20.574 38.6444 20.6369C38.6962 20.6916 38.7206 20.7668 38.7108 20.8415C38.6994 20.9274 38.6062 21.0182 38.4197 21.1998L36.6507 22.9228C36.5956 22.9766 36.568 23.0034 36.5502 23.0354C36.5345 23.0637 36.5244 23.0947 36.5205 23.1269C36.5161 23.1632 36.5226 23.2011 36.5356 23.277L36.953 25.7107C36.997 25.9674 37.019 26.0957 36.9776 26.1719C36.9417 26.2381 36.8777 26.2846 36.8035 26.2984C36.7183 26.3142 36.6031 26.2536 36.3726 26.1323L34.1862 24.9826C34.1181 24.9467 34.084 24.9288 34.0481 24.9218C34.0163 24.9155 33.9837 24.9155 33.9519 24.9218C33.916 24.9288 33.882 24.9467 33.8138 24.9826L31.6275 26.1323C31.397 26.2536 31.2817 26.3142 31.1965 26.2984C31.1223 26.2846 31.0584 26.2381 31.0224 26.1719C30.981 26.0957 31.003 25.9674 31.047 25.7107L31.4644 23.277C31.4775 23.2011 31.484 23.1632 31.4796 23.1269C31.4757 23.0947 31.4656 23.0637 31.4498 23.0354C31.432 23.0034 31.4044 22.9766 31.3493 22.9228L29.5803 21.1998C29.3938 21.0182 29.3006 20.9274 29.2893 20.8415C29.2794 20.7668 29.3038 20.6916 29.3556 20.6369C29.4152 20.574 29.544 20.5551 29.8015 20.5175L32.2472 20.16C32.3232 20.1489 32.3612 20.1433 32.3944 20.1279C32.4237 20.1143 32.4501 20.0951 32.4721 20.0714C32.497 20.0447 32.514 20.0102 32.548 19.9413L33.6413 17.7263Z",
    stroke: "#EAAA08",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6945_17466"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(28 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingrwStIcon);
export default __webpack_public_path__ + "static/media/pendingrw_stIcon.e5b4fd8bee3d243badeb8eb0dba1f504.svg";
export { ForwardRef as ReactComponent };